import { useRootSelector } from "screens/Root/hooks/useAppSelector";
import { useEffect, useState } from "react";
export const useStartupLoading = () => {
    const [timeouted, setTimeouted] = useState(false);
    const rootState = useRootSelector();
    const isLogged = rootState.isLogged;
    const initialTabInitialized = rootState.tabs[Object.keys(rootState.tabs)[0]].initialized;
    const headlessLoginResult = rootState.headlessLoginResult;
    useEffect(() => {
        const timeout = setTimeout(() => {
            setTimeouted(true);
        }, 30 * 1000);
        return () => clearTimeout(timeout);
    }, []);
    return timeouted ? false : isLogged
        && !initialTabInitialized
        && (!headlessLoginResult || headlessLoginResult.success);
};
